import {useTranslation} from 'react-i18next';
import MiniFormDialog from '../../../../components/modal/miniFormDialog';
import PlansForm from './plansForm';
import {useDispatch} from 'react-redux';
import {useState} from 'react';
import moment from 'moment/moment';
import Notes from '../../../../util/notes';
import {setSnackbar} from '../../../../store/reducers/globals';

const NursingPlan = (props) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    // const [values, setValues] = useState(props.patient?.studies?.nursingPlanNote);
    const [values, setValues] = useState({...props.patient?.studies?.nursingPlanNote, who: null, when: moment()});
    const [formIsModified, setFormIsModified] = useState(false);

    const sendChange = () => {
        if (moment(values.when).isValid()) {
            props.onChange([{
                name: `studies.nursingPlanNote`,
                value: values,
                noteToAdd: Notes.getPlansNote(props._formTitle, values, props.patient?.studies?.nursingPlanNote),
            }]);
            props.onClose();
        } else {
            dispatch(setSnackbar({type: 'error', message: t('Date input is not correct.')}));
        }
    };

    return (
        <MiniFormDialog
            title={t(props._formTitle)}
            open={props.open}
            onClose={props.onClose}
            disableSubmit={!formIsModified}
            onSave={sendChange}
            formOptions={props._formOptions}
        >
            <PlansForm
                label="Clinician"
                type="studies.nursingPlanNote"
                withText
                withNotes
                allowedConsultants="nursingPlan"
                onChangingValues={setValues}
                value={values}
                setFormIsModified={setFormIsModified}
                {...props}
            />
        </MiniFormDialog>
    );
};

export default NursingPlan;